import axios from 'axios';
import { loginreq, req } from './axiosFun';
import { getHttpParams } from '../utils/util';

// 站点列表
export const getGun = (params) => { return req("get", "/admin/gun?"+getHttpParams(params)) };
//新增
export const addGun = (params) => { return req("get", "/admin/gun/create?"+getHttpParams(params)) };

export const updateGun = (id, params) => { return req("patch", "/admin/gun/"+id+'?'+getHttpParams(params)) };

export const deleteGun = (id) => { return req("delete", "/admin/gun/"+id) };



// WEBPACK FOOTER //
// ./src/api/gun.js